module.exports = __webpack_public_path__ + "fonts/manrope-light.f3126051.woff";